module.exports = [
	{
		"curdate": "2014-01-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 43,
		"temperature_1_high": 60,
		"temperature_1_low": 43,
		"temperature_2_high": 61,
		"temperature_2_low": 45,
		"temperature_3_high": 60,
		"temperature_3_low": 46,
		"observed_high": 63,
		"observed_low": 44
	},
	{
		"curdate": "2014-01-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 45,
		"temperature_1_high": 61,
		"temperature_1_low": 44,
		"temperature_2_high": 60,
		"temperature_2_low": 47,
		"temperature_3_high": 59,
		"temperature_3_low": 44,
		"observed_high": 64,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 44,
		"temperature_1_high": 61,
		"temperature_1_low": 45,
		"temperature_2_high": 59,
		"temperature_2_low": 42,
		"temperature_3_high": 56,
		"temperature_3_low": 44,
		"observed_high": 66,
		"observed_low": 48
	},
	{
		"curdate": "2014-01-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 58,
		"temperature_0_low": 46,
		"temperature_1_high": 56,
		"temperature_1_low": 46,
		"temperature_2_high": 57,
		"temperature_2_low": 45,
		"temperature_3_high": 58,
		"temperature_3_low": 47,
		"observed_high": 61,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 45,
		"temperature_1_high": 58,
		"temperature_1_low": 47,
		"temperature_2_high": 55,
		"temperature_2_low": 46,
		"temperature_3_high": 57,
		"temperature_3_low": 45,
		"observed_high": 56,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 46,
		"temperature_1_high": 58,
		"temperature_1_low": 44,
		"temperature_2_high": 61,
		"temperature_2_low": 46,
		"temperature_3_high": 63,
		"temperature_3_low": 46,
		"observed_high": 55,
		"observed_low": 47
	},
	{
		"curdate": "2014-01-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 45,
		"temperature_1_high": 62,
		"temperature_1_low": 46,
		"temperature_2_high": 64,
		"temperature_2_low": 47,
		"temperature_3_high": 64,
		"temperature_3_low": 47,
		"observed_high": 59,
		"observed_low": 47
	},
	{
		"curdate": "2014-01-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 46,
		"temperature_1_high": 65,
		"temperature_1_low": 47,
		"temperature_2_high": 64,
		"temperature_2_low": 48,
		"temperature_3_high": 63,
		"temperature_3_low": 46,
		"observed_high": 67,
		"observed_low": 47
	},
	{
		"curdate": "2014-01-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 47,
		"temperature_1_high": 66,
		"temperature_1_low": 47,
		"temperature_2_high": 64,
		"temperature_2_low": 47,
		"temperature_3_high": 63,
		"temperature_3_low": 43,
		"observed_high": 68,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 48,
		"temperature_1_high": 67,
		"temperature_1_low": 47,
		"temperature_2_high": 64,
		"temperature_2_low": 45,
		"temperature_3_high": 62,
		"temperature_3_low": 44,
		"observed_high": 71,
		"observed_low": 52
	},
	{
		"curdate": "2014-01-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 47,
		"temperature_1_high": 65,
		"temperature_1_low": 46,
		"temperature_2_high": 63,
		"temperature_2_low": 44,
		"temperature_3_high": 62,
		"temperature_3_low": 45,
		"observed_high": 72,
		"observed_low": 51
	},
	{
		"curdate": "2014-01-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 46,
		"temperature_1_high": 65,
		"temperature_1_low": 46,
		"temperature_2_high": 62,
		"temperature_2_low": 46,
		"temperature_3_high": 63,
		"temperature_3_low": 44,
		"observed_high": 67,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 46,
		"temperature_1_high": 64,
		"temperature_1_low": 46,
		"temperature_2_high": 63,
		"temperature_2_low": 46,
		"temperature_3_high": 64,
		"temperature_3_low": 45,
		"observed_high": 69,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 46,
		"temperature_1_high": 68,
		"temperature_1_low": 45,
		"temperature_2_high": 66,
		"temperature_2_low": 46,
		"temperature_3_high": 66,
		"temperature_3_low": 44,
		"observed_high": 65,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 45,
		"temperature_1_high": 63,
		"temperature_1_low": 44,
		"temperature_2_high": 61,
		"temperature_2_low": 45,
		"temperature_3_high": 62,
		"temperature_3_low": 47,
		"observed_high": 69,
		"observed_low": 48
	},
	{
		"curdate": "2014-01-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 44,
		"temperature_1_high": 63,
		"temperature_1_low": 45,
		"temperature_2_high": 61,
		"temperature_2_low": 45,
		"temperature_3_high": 62,
		"temperature_3_low": 45,
		"observed_high": 66,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 45,
		"temperature_1_high": 62,
		"temperature_1_low": 46,
		"temperature_2_high": 60,
		"temperature_2_low": 46,
		"temperature_3_high": 62,
		"temperature_3_low": 45,
		"observed_high": 69,
		"observed_low": 48
	},
	{
		"curdate": "2014-01-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 47,
		"temperature_1_high": 62,
		"temperature_1_low": 45,
		"temperature_2_high": 62,
		"temperature_2_low": 45,
		"temperature_3_high": 63,
		"temperature_3_low": 47,
		"observed_high": 68,
		"observed_low": 48
	},
	{
		"curdate": "2014-01-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 46,
		"temperature_1_high": 62,
		"temperature_1_low": 45,
		"temperature_2_high": 60,
		"temperature_2_low": 44,
		"temperature_3_high": 60,
		"temperature_3_low": 49,
		"observed_high": 65,
		"observed_low": 49
	},
	{
		"curdate": "2014-01-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 46,
		"temperature_1_high": 61,
		"temperature_1_low": 47,
		"temperature_2_high": 58,
		"temperature_2_low": 48,
		"temperature_3_high": 61,
		"temperature_3_low": 51,
		"observed_high": 71,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 47,
		"temperature_1_high": 60,
		"temperature_1_low": 50,
		"temperature_2_high": 60,
		"temperature_2_low": 49,
		"temperature_3_high": 61,
		"temperature_3_low": 50,
		"observed_high": 58,
		"observed_low": 48
	},
	{
		"curdate": "2014-01-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 52,
		"temperature_1_high": 59,
		"temperature_1_low": 50,
		"temperature_2_high": 56,
		"temperature_2_low": 47,
		"temperature_3_high": 56,
		"temperature_3_low": 43,
		"observed_high": 61,
		"observed_low": 54
	},
	{
		"curdate": "2014-01-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 45,
		"temperature_1_high": 55,
		"temperature_1_low": 43,
		"temperature_2_high": 53,
		"temperature_2_low": 40,
		"temperature_3_high": 55,
		"temperature_3_low": 43,
		"observed_high": 58,
		"observed_low": 48
	},
	{
		"curdate": "2014-02-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 43,
		"temperature_1_high": 52,
		"temperature_1_low": 41,
		"temperature_2_high": 53,
		"temperature_2_low": 42,
		"temperature_3_high": 52,
		"temperature_3_low": 42,
		"observed_high": 50,
		"observed_low": 45
	},
	{
		"curdate": "2014-02-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 54,
		"temperature_0_low": 42,
		"temperature_1_high": 54,
		"temperature_1_low": 43,
		"temperature_2_high": 53,
		"temperature_2_low": 43,
		"temperature_3_high": 54,
		"temperature_3_low": 44,
		"observed_high": 53,
		"observed_low": 44
	},
	{
		"curdate": "2014-02-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 53,
		"temperature_0_low": 45,
		"temperature_1_high": 54,
		"temperature_1_low": 46,
		"temperature_2_high": 55,
		"temperature_2_low": 49,
		"temperature_3_high": 56,
		"temperature_3_low": 50,
		"observed_high": 53,
		"observed_low": 42
	},
	{
		"curdate": "2014-02-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 54,
		"temperature_0_low": 45,
		"temperature_1_high": 55,
		"temperature_1_low": 49,
		"temperature_2_high": 56,
		"temperature_2_low": 51,
		"temperature_3_high": 57,
		"temperature_3_low": 49,
		"observed_high": 52,
		"observed_low": 46
	},
	{
		"curdate": "2014-02-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 55,
		"temperature_0_low": 49,
		"temperature_1_high": 57,
		"temperature_1_low": 51,
		"temperature_2_high": 57,
		"temperature_2_low": 50,
		"temperature_3_high": 60,
		"temperature_3_low": 48,
		"observed_high": 55,
		"observed_low": 51
	},
	{
		"curdate": "2014-02-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 55,
		"temperature_0_low": 51,
		"temperature_1_high": 57,
		"temperature_1_low": 50,
		"temperature_2_high": 58,
		"temperature_2_low": 48,
		"temperature_3_high": 59,
		"temperature_3_low": 49,
		"observed_high": 58,
		"observed_low": 52
	},
	{
		"curdate": "2014-02-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 50,
		"temperature_1_high": 59,
		"temperature_1_low": 48,
		"temperature_2_high": 58,
		"temperature_2_low": 48,
		"temperature_3_high": 59,
		"temperature_3_low": 50,
		"observed_high": 58,
		"observed_low": 56
	},
	{
		"curdate": "2014-02-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 47,
		"temperature_1_high": 57,
		"temperature_1_low": 47,
		"temperature_2_high": 59,
		"temperature_2_low": 50,
		"temperature_3_high": 61,
		"temperature_3_low": 50,
		"observed_high": 58,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 51,
		"temperature_1_high": 60,
		"temperature_1_low": 50,
		"temperature_2_high": 58,
		"temperature_2_low": 49,
		"temperature_3_high": 58,
		"temperature_3_low": 46,
		"observed_high": 62,
		"observed_low": 54
	},
	{
		"curdate": "2014-02-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 45,
		"temperature_1_high": 59,
		"temperature_1_low": 47,
		"temperature_2_high": 59,
		"temperature_2_low": 48,
		"temperature_3_high": 58,
		"temperature_3_low": 45,
		"observed_high": 61,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 48,
		"temperature_1_high": 60,
		"temperature_1_low": 45,
		"temperature_2_high": 59,
		"temperature_2_low": 46,
		"temperature_3_high": 62,
		"temperature_3_low": 46,
		"observed_high": 61,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 45,
		"temperature_1_high": 61,
		"temperature_1_low": 46,
		"temperature_2_high": 61,
		"temperature_2_low": 46,
		"temperature_3_high": 62,
		"temperature_3_low": 47,
		"observed_high": 59,
		"observed_low": 51
	},
	{
		"curdate": "2014-02-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 47,
		"temperature_1_high": 61,
		"temperature_1_low": 46,
		"temperature_2_high": 61,
		"temperature_2_low": 46,
		"temperature_3_high": 61,
		"temperature_3_low": 47,
		"observed_high": 66,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 47,
		"temperature_1_high": 61,
		"temperature_1_low": 47,
		"temperature_2_high": 58,
		"temperature_2_low": 47,
		"temperature_3_high": 61,
		"temperature_3_low": 48,
		"observed_high": 69,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 46,
		"temperature_1_high": 61,
		"temperature_1_low": 47,
		"temperature_2_high": 61,
		"temperature_2_low": 49,
		"temperature_3_high": 62,
		"temperature_3_low": 50,
		"observed_high": 64,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 47,
		"temperature_1_high": 62,
		"temperature_1_low": 48,
		"temperature_2_high": 59,
		"temperature_2_low": 50,
		"temperature_3_high": 57,
		"temperature_3_low": 49,
		"observed_high": 63,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 48,
		"temperature_1_high": 61,
		"temperature_1_low": 49,
		"temperature_2_high": 58,
		"temperature_2_low": 50,
		"temperature_3_high": 59,
		"temperature_3_low": 49,
		"observed_high": 69,
		"observed_low": 48
	},
	{
		"curdate": "2014-02-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 59,
		"temperature_1_low": 50,
		"temperature_2_high": 58,
		"temperature_2_low": 49,
		"temperature_3_high": 57,
		"temperature_3_low": 49,
		"observed_high": 61,
		"observed_low": 49
	},
	{
		"curdate": "2014-02-26",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 50,
		"temperature_1_high": 59,
		"temperature_1_low": 50,
		"temperature_2_high": 57,
		"temperature_2_low": 49,
		"temperature_3_high": 59,
		"temperature_3_low": 47,
		"observed_high": 58,
		"observed_low": 54
	},
	{
		"curdate": "2014-02-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 50,
		"temperature_1_high": 57,
		"temperature_1_low": 48,
		"temperature_2_high": 58,
		"temperature_2_low": 47,
		"temperature_3_high": 59,
		"temperature_3_low": 48,
		"observed_high": 64,
		"observed_low": 54
	},
	{
		"curdate": "2014-02-28",
		"location": "san-francisco-ca",
		"temperature_0_high": 58,
		"temperature_0_low": 49,
		"temperature_1_high": 60,
		"temperature_1_low": 48,
		"temperature_2_high": 58,
		"temperature_2_low": 49,
		"temperature_3_high": 59,
		"temperature_3_low": 50,
		"observed_high": 61,
		"observed_low": 54
	},
	{
		"curdate": "2014-03-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 52,
		"temperature_1_high": 60,
		"temperature_1_low": 52,
		"temperature_2_high": 60,
		"temperature_2_low": 50,
		"temperature_3_high": 62,
		"temperature_3_low": 51,
		"observed_high": 65,
		"observed_low": 54
	},
	{
		"curdate": "2014-03-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 50,
		"temperature_1_high": 59,
		"temperature_1_low": 50,
		"temperature_2_high": 60,
		"temperature_2_low": 51,
		"temperature_3_high": 61,
		"temperature_3_low": 52,
		"observed_high": 59,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 50,
		"temperature_1_high": 61,
		"temperature_1_low": 50,
		"temperature_2_high": 60,
		"temperature_2_low": 52,
		"temperature_3_high": 61,
		"temperature_3_low": 48,
		"observed_high": 60,
		"observed_low": 52
	},
	{
		"curdate": "2014-03-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 51,
		"temperature_1_high": 62,
		"temperature_1_low": 52,
		"temperature_2_high": 60,
		"temperature_2_low": 48,
		"temperature_3_high": 62,
		"temperature_3_low": 48,
		"observed_high": 61,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 52,
		"temperature_1_high": 61,
		"temperature_1_low": 49,
		"temperature_2_high": 63,
		"temperature_2_low": 48,
		"temperature_3_high": 65,
		"temperature_3_low": 51,
		"observed_high": 63,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 48,
		"temperature_1_high": 64,
		"temperature_1_low": 51,
		"temperature_2_high": 63,
		"temperature_2_low": 51,
		"temperature_3_high": 62,
		"temperature_3_low": 48,
		"observed_high": 71,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 55,
		"temperature_1_high": 63,
		"temperature_1_low": 47,
		"temperature_2_high": 65,
		"temperature_2_low": 47,
		"temperature_3_high": 65,
		"temperature_3_low": 49,
		"observed_high": 66,
		"observed_low": 54
	},
	{
		"curdate": "2014-03-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 47,
		"temperature_1_high": 64,
		"temperature_1_low": 48,
		"temperature_2_high": 68,
		"temperature_2_low": 48,
		"temperature_3_high": 69,
		"temperature_3_low": 48,
		"observed_high": 73,
		"observed_low": 59
	},
	{
		"curdate": "2014-03-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 50,
		"temperature_1_high": 70,
		"temperature_1_low": 51,
		"temperature_2_high": 69,
		"temperature_2_low": 50,
		"temperature_3_high": 64,
		"temperature_3_low": 47,
		"observed_high": 66,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 50,
		"temperature_1_high": 70,
		"temperature_1_low": 49,
		"temperature_2_high": 63,
		"temperature_2_low": 47,
		"temperature_3_high": 68,
		"temperature_3_low": 47,
		"observed_high": 76,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 49,
		"temperature_1_high": 63,
		"temperature_1_low": 47,
		"temperature_2_high": 65,
		"temperature_2_low": 47,
		"temperature_3_high": 65,
		"temperature_3_low": 49,
		"observed_high": 66,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 47,
		"temperature_1_high": 66,
		"temperature_1_low": 48,
		"temperature_2_high": 65,
		"temperature_2_low": 49,
		"temperature_3_high": 65,
		"temperature_3_low": 48,
		"observed_high": 64,
		"observed_low": 51
	},
	{
		"curdate": "2014-03-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 48,
		"temperature_1_high": 67,
		"temperature_1_low": 49,
		"temperature_2_high": 65,
		"temperature_2_low": 49,
		"temperature_3_high": 65,
		"temperature_3_low": 49,
		"observed_high": 69,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 50,
		"temperature_2_high": 65,
		"temperature_2_low": 49,
		"temperature_3_high": 63,
		"temperature_3_low": 50,
		"observed_high": 72,
		"observed_low": 51
	},
	{
		"curdate": "2014-03-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 49,
		"temperature_1_high": 63,
		"temperature_1_low": 48,
		"temperature_2_high": 64,
		"temperature_2_low": 48,
		"temperature_3_high": 66,
		"temperature_3_low": 48,
		"observed_high": 64,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 47,
		"temperature_1_high": 64,
		"temperature_1_low": 49,
		"temperature_2_high": 64,
		"temperature_2_low": 48,
		"temperature_3_high": 65,
		"temperature_3_low": 49,
		"observed_high": 61,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 48,
		"temperature_1_high": 63,
		"temperature_1_low": 49,
		"temperature_2_high": 64,
		"temperature_2_low": 49,
		"temperature_3_high": 59,
		"temperature_3_low": 52,
		"observed_high": 62,
		"observed_low": 49
	},
	{
		"curdate": "2014-03-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 64,
		"temperature_1_low": 49,
		"temperature_2_high": 58,
		"temperature_2_low": 53,
		"temperature_3_high": 59,
		"temperature_3_low": 50,
		"observed_high": 60,
		"observed_low": 49
	},
	{
		"curdate": "2014-03-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 60,
		"temperature_1_low": 49,
		"temperature_2_high": 59,
		"temperature_2_low": 53,
		"temperature_3_high": 61,
		"temperature_3_low": 51,
		"observed_high": 60,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 58,
		"temperature_0_low": 48,
		"temperature_1_high": 60,
		"temperature_1_low": 51,
		"temperature_2_high": 62,
		"temperature_2_low": 52,
		"temperature_3_high": 61,
		"temperature_3_low": 48,
		"observed_high": 63,
		"observed_low": 53
	},
	{
		"curdate": "2014-03-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 48,
		"temperature_1_high": 58,
		"temperature_1_low": 46,
		"temperature_2_high": 56,
		"temperature_2_low": 48,
		"temperature_3_high": 56,
		"temperature_3_low": 46,
		"observed_high": 59,
		"observed_low": 51
	},
	{
		"curdate": "2014-03-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 46,
		"temperature_1_high": 57,
		"temperature_1_low": 46,
		"temperature_2_high": 57,
		"temperature_2_low": 48,
		"temperature_3_high": 61,
		"temperature_3_low": 48,
		"observed_high": 59,
		"observed_low": 50
	},
	{
		"curdate": "2014-03-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 46,
		"temperature_1_high": 57,
		"temperature_1_low": 45,
		"temperature_2_high": 59,
		"temperature_2_low": 46,
		"temperature_3_high": 61,
		"temperature_3_low": 47,
		"observed_high": 56,
		"observed_low": 47
	},
	{
		"curdate": "2014-04-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 45,
		"temperature_1_high": 59,
		"temperature_1_low": 46,
		"temperature_2_high": 60,
		"temperature_2_low": 51,
		"temperature_3_high": 61,
		"temperature_3_low": 48,
		"observed_high": 57,
		"observed_low": 46
	},
	{
		"curdate": "2014-04-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 46,
		"temperature_1_high": 59,
		"temperature_1_low": 48,
		"temperature_2_high": 59,
		"temperature_2_low": 48,
		"temperature_3_high": 64,
		"temperature_3_low": 49,
		"observed_high": 59,
		"observed_low": 46
	},
	{
		"curdate": "2014-04-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 48,
		"temperature_1_high": 59,
		"temperature_1_low": 48,
		"temperature_2_high": 63,
		"temperature_2_low": 49,
		"temperature_3_high": 69,
		"temperature_3_low": 51,
		"observed_high": 60,
		"observed_low": 50
	},
	{
		"curdate": "2014-04-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 48,
		"temperature_1_high": 62,
		"temperature_1_low": 49,
		"temperature_2_high": 68,
		"temperature_2_low": 53,
		"temperature_3_high": 72,
		"temperature_3_low": 54,
		"observed_high": 58,
		"observed_low": 50
	},
	{
		"curdate": "2014-04-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 67,
		"temperature_1_low": 51,
		"temperature_2_high": 70,
		"temperature_2_low": 53,
		"temperature_3_high": 72,
		"temperature_3_low": 52,
		"observed_high": 71,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 50,
		"temperature_2_high": 67,
		"temperature_2_low": 53,
		"temperature_3_high": 65,
		"temperature_3_low": 50,
		"observed_high": 75,
		"observed_low": 52
	},
	{
		"curdate": "2014-04-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 49,
		"temperature_1_high": 62,
		"temperature_1_low": 49,
		"temperature_2_high": 62,
		"temperature_2_low": 49,
		"temperature_3_high": 63,
		"temperature_3_low": 49,
		"observed_high": 68,
		"observed_low": 49
	},
	{
		"curdate": "2014-04-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 49,
		"temperature_1_high": 61,
		"temperature_1_low": 48,
		"temperature_2_high": 63,
		"temperature_2_low": 51,
		"temperature_3_high": 65,
		"temperature_3_low": 51,
		"observed_high": 60,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 48,
		"temperature_1_high": 64,
		"temperature_1_low": 50,
		"temperature_2_high": 64,
		"temperature_2_low": 50,
		"temperature_3_high": 62,
		"temperature_3_low": 48,
		"observed_high": 61,
		"observed_low": 53
	},
	{
		"curdate": "2014-04-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 50,
		"temperature_1_high": 66,
		"temperature_1_low": 50,
		"temperature_2_high": 62,
		"temperature_2_low": 48,
		"temperature_3_high": 66,
		"temperature_3_low": 50,
		"observed_high": 63,
		"observed_low": 52
	},
	{
		"curdate": "2014-04-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 50,
		"temperature_1_high": 64,
		"temperature_1_low": 50,
		"temperature_2_high": 66,
		"temperature_2_low": 51,
		"temperature_3_high": 67,
		"temperature_3_low": 50,
		"observed_high": 65,
		"observed_low": 52
	},
	{
		"curdate": "2014-04-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 50,
		"temperature_1_high": 67,
		"temperature_1_low": 51,
		"temperature_2_high": 65,
		"temperature_2_low": 51,
		"temperature_3_high": 65,
		"temperature_3_low": 50,
		"observed_high": 68,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 50,
		"temperature_1_high": 64,
		"temperature_1_low": 48,
		"temperature_2_high": 62,
		"temperature_2_low": 48,
		"temperature_3_high": 66,
		"temperature_3_low": 50,
		"observed_high": 60,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 50,
		"temperature_1_high": 61,
		"temperature_1_low": 49,
		"temperature_2_high": 59,
		"temperature_2_low": 47,
		"temperature_3_high": 63,
		"temperature_3_low": 52,
		"observed_high": 75,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 59,
		"temperature_1_low": 47,
		"temperature_2_high": 62,
		"temperature_2_low": 51,
		"temperature_3_high": 62,
		"temperature_3_low": 54,
		"observed_high": 63,
		"observed_low": 51
	},
	{
		"curdate": "2014-04-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 47,
		"temperature_1_high": 63,
		"temperature_1_low": 49,
		"temperature_2_high": 62,
		"temperature_2_low": 53,
		"temperature_3_high": 58,
		"temperature_3_low": 47,
		"observed_high": 59,
		"observed_low": 50
	},
	{
		"curdate": "2014-04-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 50,
		"temperature_1_high": 62,
		"temperature_1_low": 50,
		"temperature_2_high": 57,
		"temperature_2_low": 46,
		"temperature_3_high": 59,
		"temperature_3_low": 51,
		"observed_high": 61,
		"observed_low": 53
	},
	{
		"curdate": "2014-04-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 47,
		"temperature_1_high": 58,
		"temperature_1_low": 49,
		"temperature_2_high": 61,
		"temperature_2_low": 47,
		"temperature_3_high": 67,
		"temperature_3_low": 49,
		"observed_high": 56,
		"observed_low": 50
	},
	{
		"curdate": "2014-04-26",
		"location": "san-francisco-ca",
		"temperature_0_high": 58,
		"temperature_0_low": 50,
		"temperature_1_high": 60,
		"temperature_1_low": 48,
		"temperature_2_high": 65,
		"temperature_2_low": 50,
		"temperature_3_high": 74,
		"temperature_3_low": 54,
		"observed_high": 58,
		"observed_low": 47
	},
	{
		"curdate": "2014-04-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 48,
		"temperature_1_high": 65,
		"temperature_1_low": 50,
		"temperature_2_high": 73,
		"temperature_2_low": 54,
		"temperature_3_high": 80,
		"temperature_3_low": 57,
		"observed_high": 61,
		"observed_low": 50
	},
	{
		"curdate": "2014-04-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 51,
		"temperature_1_high": 72,
		"temperature_1_low": 53,
		"temperature_2_high": 77,
		"temperature_2_low": 57,
		"temperature_3_high": 77,
		"temperature_3_low": 54,
		"observed_high": 81,
		"observed_low": 54
	},
	{
		"curdate": "2014-05-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 89,
		"temperature_0_low": 55,
		"temperature_1_high": 76,
		"temperature_1_low": 52,
		"temperature_2_high": 67,
		"temperature_2_low": 51,
		"temperature_3_high": 62,
		"temperature_3_low": 51,
		"observed_high": 84,
		"observed_low": 62
	},
	{
		"curdate": "2014-05-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 51,
		"temperature_1_high": 63,
		"temperature_1_low": 51,
		"temperature_2_high": 61,
		"temperature_2_low": 50,
		"temperature_3_high": 63,
		"temperature_3_low": 49,
		"observed_high": 62,
		"observed_low": 52
	},
	{
		"curdate": "2014-05-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 55,
		"temperature_1_high": 62,
		"temperature_1_low": 50,
		"temperature_2_high": 66,
		"temperature_2_low": 51,
		"temperature_3_high": 65,
		"temperature_3_low": 52,
		"observed_high": 65,
		"observed_low": 54
	},
	{
		"curdate": "2014-05-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 48,
		"temperature_1_high": 62,
		"temperature_1_low": 49,
		"temperature_2_high": 63,
		"temperature_2_low": 52,
		"temperature_3_high": 63,
		"temperature_3_low": 54,
		"observed_high": 62,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 48,
		"temperature_1_high": 62,
		"temperature_1_low": 50,
		"temperature_2_high": 63,
		"temperature_2_low": 54,
		"temperature_3_high": 64,
		"temperature_3_low": 51,
		"observed_high": 66,
		"observed_low": 51
	},
	{
		"curdate": "2014-05-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 50,
		"temperature_1_high": 63,
		"temperature_1_low": 53,
		"temperature_2_high": 64,
		"temperature_2_low": 50,
		"temperature_3_high": 65,
		"temperature_3_low": 49,
		"observed_high": 62,
		"observed_low": 50
	},
	{
		"curdate": "2014-05-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 53,
		"temperature_1_high": 63,
		"temperature_1_low": 49,
		"temperature_2_high": 64,
		"temperature_2_low": 51,
		"temperature_3_high": 70,
		"temperature_3_low": 51,
		"observed_high": 63,
		"observed_low": 52
	},
	{
		"curdate": "2014-05-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 49,
		"temperature_1_high": 69,
		"temperature_1_low": 49,
		"temperature_2_high": 73,
		"temperature_2_low": 53,
		"temperature_3_high": 81,
		"temperature_3_low": 57,
		"observed_high": 73,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 86,
		"temperature_0_low": 58,
		"temperature_1_high": 87,
		"temperature_1_low": 57,
		"temperature_2_high": 77,
		"temperature_2_low": 53,
		"temperature_3_high": 72,
		"temperature_3_low": 53,
		"observed_high": 90,
		"observed_low": 59
	},
	{
		"curdate": "2014-05-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 85,
		"temperature_0_low": 56,
		"temperature_1_high": 75,
		"temperature_1_low": 52,
		"temperature_2_high": 70,
		"temperature_2_low": 53,
		"temperature_3_high": 67,
		"temperature_3_low": 52,
		"observed_high": 88,
		"observed_low": 64
	},
	{
		"curdate": "2014-05-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 51,
		"temperature_2_high": 63,
		"temperature_2_low": 53,
		"temperature_3_high": 62,
		"temperature_3_low": 51,
		"observed_high": 65,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 52,
		"temperature_1_high": 64,
		"temperature_1_low": 50,
		"temperature_2_high": 62,
		"temperature_2_low": 51,
		"temperature_3_high": 64,
		"temperature_3_low": 51,
		"observed_high": 61,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 51,
		"temperature_1_high": 61,
		"temperature_1_low": 49,
		"temperature_2_high": 63,
		"temperature_2_low": 51,
		"temperature_3_high": 65,
		"temperature_3_low": 52,
		"observed_high": 63,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 51,
		"temperature_1_high": 63,
		"temperature_1_low": 50,
		"temperature_2_high": 65,
		"temperature_2_low": 52,
		"temperature_3_high": 66,
		"temperature_3_low": 53,
		"observed_high": 64,
		"observed_low": 53
	},
	{
		"curdate": "2014-05-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 52,
		"temperature_1_high": 69,
		"temperature_1_low": 53,
		"temperature_2_high": 71,
		"temperature_2_low": 53,
		"temperature_3_high": 75,
		"temperature_3_low": 54,
		"observed_high": 65,
		"observed_low": 51
	},
	{
		"curdate": "2014-05-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 53,
		"temperature_1_high": 70,
		"temperature_1_low": 53,
		"temperature_2_high": 73,
		"temperature_2_low": 53,
		"temperature_3_high": 71,
		"temperature_3_low": 50,
		"observed_high": 63,
		"observed_low": 51
	},
	{
		"curdate": "2014-05-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 52,
		"temperature_1_high": 73,
		"temperature_1_low": 53,
		"temperature_2_high": 74,
		"temperature_2_low": 53,
		"temperature_3_high": 70,
		"temperature_3_low": 49,
		"observed_high": 62,
		"observed_low": 52
	},
	{
		"curdate": "2014-05-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 52,
		"temperature_1_high": 72,
		"temperature_1_low": 51,
		"temperature_2_high": 67,
		"temperature_2_low": 49,
		"temperature_3_high": 70,
		"temperature_3_low": 50,
		"observed_high": 70,
		"observed_low": 52
	},
	{
		"curdate": "2014-05-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 50,
		"temperature_1_high": 65,
		"temperature_1_low": 50,
		"temperature_2_high": 67,
		"temperature_2_low": 50,
		"temperature_3_high": 70,
		"temperature_3_low": 51,
		"observed_high": 65,
		"observed_low": 51
	},
	{
		"curdate": "2014-05-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 50,
		"temperature_1_high": 63,
		"temperature_1_low": 50,
		"temperature_2_high": 63,
		"temperature_2_low": 51,
		"temperature_3_high": 68,
		"temperature_3_low": 52,
		"observed_high": 72,
		"observed_low": 52
	},
	{
		"curdate": "2014-05-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 50,
		"temperature_1_high": 64,
		"temperature_1_low": 51,
		"temperature_2_high": 68,
		"temperature_2_low": 52,
		"temperature_3_high": 66,
		"temperature_3_low": 52,
		"observed_high": 58,
		"observed_low": 51
	},
	{
		"curdate": "2014-05-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 51,
		"temperature_2_high": 63,
		"temperature_2_low": 52,
		"temperature_3_high": 63,
		"temperature_3_low": 51,
		"observed_high": 64,
		"observed_low": 50
	},
	{
		"curdate": "2014-06-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 51,
		"temperature_1_high": 60,
		"temperature_1_low": 50,
		"temperature_2_high": 64,
		"temperature_2_low": 51,
		"temperature_3_high": 71,
		"temperature_3_low": 53,
		"observed_high": 64,
		"observed_low": 51
	},
	{
		"curdate": "2014-06-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 50,
		"temperature_1_high": 64,
		"temperature_1_low": 51,
		"temperature_2_high": 66,
		"temperature_2_low": 52,
		"temperature_3_high": 68,
		"temperature_3_low": 53,
		"observed_high": 63,
		"observed_low": 51
	},
	{
		"curdate": "2014-06-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 52,
		"temperature_1_high": 67,
		"temperature_1_low": 52,
		"temperature_2_high": 67,
		"temperature_2_low": 53,
		"temperature_3_high": 73,
		"temperature_3_low": 53,
		"observed_high": 67,
		"observed_low": 51
	},
	{
		"curdate": "2014-06-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 52,
		"temperature_1_high": 66,
		"temperature_1_low": 52,
		"temperature_2_high": 69,
		"temperature_2_low": 53,
		"temperature_3_high": 74,
		"temperature_3_low": 55,
		"observed_high": 62,
		"observed_low": 51
	},
	{
		"curdate": "2014-06-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 52,
		"temperature_1_high": 69,
		"temperature_1_low": 53,
		"temperature_2_high": 73,
		"temperature_2_low": 55,
		"temperature_3_high": 68,
		"temperature_3_low": 53,
		"observed_high": 63,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 53,
		"temperature_1_high": 74,
		"temperature_1_low": 56,
		"temperature_2_high": 70,
		"temperature_2_low": 54,
		"temperature_3_high": 66,
		"temperature_3_low": 54,
		"observed_high": 66,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 78,
		"temperature_0_low": 55,
		"temperature_1_high": 71,
		"temperature_1_low": 55,
		"temperature_2_high": 67,
		"temperature_2_low": 53,
		"temperature_3_high": 67,
		"temperature_3_low": 52,
		"observed_high": 69,
		"observed_low": 56
	},
	{
		"curdate": "2014-06-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 52,
		"temperature_1_high": 62,
		"temperature_1_low": 51,
		"temperature_2_high": 67,
		"temperature_2_low": 52,
		"temperature_3_high": 71,
		"temperature_3_low": 53,
		"observed_high": 64,
		"observed_low": 54
	},
	{
		"curdate": "2014-06-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 50,
		"temperature_2_high": 68,
		"temperature_2_low": 51,
		"temperature_3_high": 71,
		"temperature_3_low": 54,
		"observed_high": 62,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 50,
		"temperature_1_high": 68,
		"temperature_1_low": 52,
		"temperature_2_high": 66,
		"temperature_2_low": 53,
		"temperature_3_high": 66,
		"temperature_3_low": 54,
		"observed_high": 75,
		"observed_low": 54
	},
	{
		"curdate": "2014-06-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 52,
		"temperature_1_high": 64,
		"temperature_1_low": 51,
		"temperature_2_high": 67,
		"temperature_2_low": 52,
		"temperature_3_high": 72,
		"temperature_3_low": 52,
		"observed_high": 64,
		"observed_low": 53
	},
	{
		"curdate": "2014-06-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 51,
		"temperature_1_high": 67,
		"temperature_1_low": 51,
		"temperature_2_high": 68,
		"temperature_2_low": 52,
		"temperature_3_high": 67,
		"temperature_3_low": 53,
		"observed_high": 60,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 50,
		"temperature_1_high": 68,
		"temperature_1_low": 51,
		"temperature_2_high": 65,
		"temperature_2_low": 53,
		"temperature_3_high": 67,
		"temperature_3_low": 53,
		"observed_high": 67,
		"observed_low": 51
	},
	{
		"curdate": "2014-06-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 77,
		"temperature_0_low": 52,
		"temperature_1_high": 66,
		"temperature_1_low": 53,
		"temperature_2_high": 66,
		"temperature_2_low": 52,
		"temperature_3_high": 66,
		"temperature_3_low": 52,
		"observed_high": 65,
		"observed_low": 53
	},
	{
		"curdate": "2014-06-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 51,
		"temperature_1_high": 64,
		"temperature_1_low": 51,
		"temperature_2_high": 65,
		"temperature_2_low": 53,
		"temperature_3_high": 69,
		"temperature_3_low": 54,
		"observed_high": 60,
		"observed_low": 53
	},
	{
		"curdate": "2014-06-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 52,
		"temperature_1_high": 67,
		"temperature_1_low": 53,
		"temperature_2_high": 67,
		"temperature_2_low": 53,
		"temperature_3_high": 66,
		"temperature_3_low": 55,
		"observed_high": 62,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 53,
		"temperature_1_high": 68,
		"temperature_1_low": 54,
		"temperature_2_high": 66,
		"temperature_2_low": 54,
		"temperature_3_high": 67,
		"temperature_3_low": 54,
		"observed_high": 67,
		"observed_low": 52
	},
	{
		"curdate": "2014-06-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 55,
		"temperature_1_high": 66,
		"temperature_1_low": 55,
		"temperature_2_high": 66,
		"temperature_2_low": 53,
		"temperature_3_high": 69,
		"temperature_3_low": 55,
		"observed_high": 62,
		"observed_low": 54
	},
	{
		"curdate": "2014-06-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 55,
		"temperature_1_high": 67,
		"temperature_1_low": 53,
		"temperature_2_high": 71,
		"temperature_2_low": 54,
		"temperature_3_high": 76,
		"temperature_3_low": 55,
		"observed_high": 67,
		"observed_low": 55
	},
	{
		"curdate": "2014-06-28",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 54,
		"temperature_1_high": 72,
		"temperature_1_low": 54,
		"temperature_2_high": 74,
		"temperature_2_low": 55,
		"temperature_3_high": 72,
		"temperature_3_low": 54,
		"observed_high": 68,
		"observed_low": 54
	},
	{
		"curdate": "2014-06-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 55,
		"temperature_1_high": 74,
		"temperature_1_low": 56,
		"temperature_2_high": 68,
		"temperature_2_low": 55,
		"temperature_3_high": 68,
		"temperature_3_low": 55,
		"observed_high": 73,
		"observed_low": 56
	},
	{
		"curdate": "2014-07-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 54,
		"temperature_1_high": 67,
		"temperature_1_low": 54,
		"temperature_2_high": 66,
		"temperature_2_low": 53,
		"temperature_3_high": 69,
		"temperature_3_low": 54,
		"observed_high": 65,
		"observed_low": 55
	},
	{
		"curdate": "2014-07-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 54,
		"temperature_1_high": 67,
		"temperature_1_low": 54,
		"temperature_2_high": 68,
		"temperature_2_low": 54,
		"temperature_3_high": 73,
		"temperature_3_low": 54,
		"observed_high": 65,
		"observed_low": 54
	},
	{
		"curdate": "2014-07-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 54,
		"temperature_1_high": 67,
		"temperature_1_low": 53,
		"temperature_2_high": 69,
		"temperature_2_low": 54,
		"temperature_3_high": 74,
		"temperature_3_low": 56,
		"observed_high": 65,
		"observed_low": 54
	},
	{
		"curdate": "2014-07-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 54,
		"temperature_1_high": 69,
		"temperature_1_low": 53,
		"temperature_2_high": 72,
		"temperature_2_low": 55,
		"temperature_3_high": 74,
		"temperature_3_low": 56,
		"observed_high": 65,
		"observed_low": 54
	},
	{
		"curdate": "2014-07-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 55,
		"temperature_1_high": 70,
		"temperature_1_low": 56,
		"temperature_2_high": 65,
		"temperature_2_low": 56,
		"temperature_3_high": 69,
		"temperature_3_low": 56,
		"observed_high": 66,
		"observed_low": 53
	},
	{
		"curdate": "2014-07-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 55,
		"temperature_1_high": 66,
		"temperature_1_low": 55,
		"temperature_2_high": 66,
		"temperature_2_low": 55,
		"temperature_3_high": 68,
		"temperature_3_low": 55,
		"observed_high": 68,
		"observed_low": 54
	},
	{
		"curdate": "2014-07-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 56,
		"temperature_1_high": 66,
		"temperature_1_low": 55,
		"temperature_2_high": 66,
		"temperature_2_low": 56,
		"temperature_3_high": 67,
		"temperature_3_low": 55,
		"observed_high": 64,
		"observed_low": 55
	},
	{
		"curdate": "2014-07-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 56,
		"temperature_1_high": 65,
		"temperature_1_low": 55,
		"temperature_2_high": 66,
		"temperature_2_low": 55,
		"temperature_3_high": 69,
		"temperature_3_low": 55,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-07-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 55,
		"temperature_1_high": 67,
		"temperature_1_low": 55,
		"temperature_2_high": 69,
		"temperature_2_low": 55,
		"temperature_3_high": 71,
		"temperature_3_low": 56,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-07-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 54,
		"temperature_1_high": 70,
		"temperature_1_low": 54,
		"temperature_2_high": 70,
		"temperature_2_low": 57,
		"temperature_3_high": 71,
		"temperature_3_low": 57,
		"observed_high": 64,
		"observed_low": 55
	},
	{
		"curdate": "2014-07-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 55,
		"temperature_1_high": 70,
		"temperature_1_low": 56,
		"temperature_2_high": 67,
		"temperature_2_low": 56,
		"temperature_3_high": 68,
		"temperature_3_low": 56,
		"observed_high": 72,
		"observed_low": 57
	},
	{
		"curdate": "2014-07-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 58,
		"temperature_1_high": 68,
		"temperature_1_low": 57,
		"temperature_2_high": 66,
		"temperature_2_low": 57,
		"temperature_3_high": 68,
		"temperature_3_low": 56,
		"observed_high": 73,
		"observed_low": 56
	},
	{
		"curdate": "2014-07-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 57,
		"temperature_1_high": 65,
		"temperature_1_low": 56,
		"temperature_2_high": 65,
		"temperature_2_low": 56,
		"temperature_3_high": 69,
		"temperature_3_low": 56,
		"observed_high": 70,
		"observed_low": 59
	},
	{
		"curdate": "2014-07-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 59,
		"temperature_1_high": 76,
		"temperature_1_low": 58,
		"temperature_2_high": 74,
		"temperature_2_low": 57,
		"temperature_3_high": 73,
		"temperature_3_low": 57,
		"observed_high": 66,
		"observed_low": 56
	},
	{
		"curdate": "2014-08-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 58,
		"temperature_1_high": 72,
		"temperature_1_low": 57,
		"temperature_2_high": 70,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 57,
		"observed_high": 62,
		"observed_low": 56
	},
	{
		"curdate": "2014-08-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 57,
		"temperature_1_high": 68,
		"temperature_1_low": 57,
		"temperature_2_high": 70,
		"temperature_2_low": 60,
		"temperature_3_high": 73,
		"temperature_3_low": 58,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 58,
		"temperature_1_high": 70,
		"temperature_1_low": 58,
		"temperature_2_high": 71,
		"temperature_2_low": 57,
		"temperature_3_high": 73,
		"temperature_3_low": 57,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 60,
		"temperature_1_high": 71,
		"temperature_1_low": 58,
		"temperature_2_high": 70,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 57,
		"observed_high": 71,
		"observed_low": 58
	},
	{
		"curdate": "2014-08-07",
		"location": "san-francisco-ca",
		"temperature_0_high": 71,
		"temperature_0_low": 57,
		"temperature_1_high": 70,
		"temperature_1_low": 56,
		"temperature_2_high": 69,
		"temperature_2_low": 56,
		"temperature_3_high": 70,
		"temperature_3_low": 56,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 57,
		"temperature_1_high": 68,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 57,
		"temperature_3_high": 71,
		"temperature_3_low": 56,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 57,
		"temperature_1_high": 68,
		"temperature_1_low": 56,
		"temperature_2_high": 69,
		"temperature_2_low": 57,
		"temperature_3_high": 69,
		"temperature_3_low": 57,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 58,
		"temperature_1_high": 69,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 58,
		"temperature_3_high": 71,
		"temperature_3_low": 57,
		"observed_high": 70,
		"observed_low": 59
	},
	{
		"curdate": "2014-08-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 58,
		"temperature_1_high": 69,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 57,
		"temperature_3_high": 71,
		"temperature_3_low": 57,
		"observed_high": 69,
		"observed_low": 58
	},
	{
		"curdate": "2014-08-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 58,
		"temperature_1_high": 70,
		"temperature_1_low": 56,
		"temperature_2_high": 69,
		"temperature_2_low": 56,
		"temperature_3_high": 71,
		"temperature_3_low": 58,
		"observed_high": 69,
		"observed_low": 58
	},
	{
		"curdate": "2014-08-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 57,
		"temperature_1_high": 69,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 58,
		"temperature_3_high": 71,
		"temperature_3_low": 59,
		"observed_high": 67,
		"observed_low": 58
	},
	{
		"curdate": "2014-08-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 58,
		"temperature_1_high": 69,
		"temperature_1_low": 58,
		"temperature_2_high": 69,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 62,
		"observed_low": 57
	},
	{
		"curdate": "2014-08-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 59,
		"temperature_1_high": 68,
		"temperature_1_low": 58,
		"temperature_2_high": 70,
		"temperature_2_low": 58,
		"temperature_3_high": 71,
		"temperature_3_low": 58,
		"observed_high": 67,
		"observed_low": 60
	},
	{
		"curdate": "2014-08-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 58,
		"temperature_1_high": 69,
		"temperature_1_low": 56,
		"temperature_2_high": 70,
		"temperature_2_low": 57,
		"temperature_3_high": 71,
		"temperature_3_low": 57,
		"observed_high": 69,
		"observed_low": 59
	},
	{
		"curdate": "2014-08-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 57,
		"temperature_1_high": 70,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 58,
		"temperature_3_high": 71,
		"temperature_3_low": 58,
		"observed_high": 68,
		"observed_low": 59
	},
	{
		"curdate": "2014-08-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 57,
		"temperature_1_high": 68,
		"temperature_1_low": 58,
		"temperature_2_high": 68,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 69,
		"observed_low": 59
	},
	{
		"curdate": "2014-08-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 57,
		"temperature_1_high": 71,
		"temperature_1_low": 58,
		"temperature_2_high": 73,
		"temperature_2_low": 58,
		"temperature_3_high": 75,
		"temperature_3_low": 60,
		"observed_high": 68,
		"observed_low": 61
	},
	{
		"curdate": "2014-08-26",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 58,
		"temperature_1_high": 72,
		"temperature_1_low": 58,
		"temperature_2_high": 71,
		"temperature_2_low": 59,
		"temperature_3_high": 73,
		"temperature_3_low": 60,
		"observed_high": 69,
		"observed_low": 60
	},
	{
		"curdate": "2014-08-28",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 58,
		"temperature_1_high": 72,
		"temperature_1_low": 59,
		"temperature_2_high": 71,
		"temperature_2_low": 59,
		"temperature_3_high": 74,
		"temperature_3_low": 59,
		"observed_high": 68,
		"observed_low": 59
	},
	{
		"curdate": "2014-08-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 71,
		"temperature_0_low": 60,
		"temperature_1_high": 72,
		"temperature_1_low": 59,
		"temperature_2_high": 73,
		"temperature_2_low": 59,
		"temperature_3_high": 77,
		"temperature_3_low": 60,
		"observed_high": 69,
		"observed_low": 58
	},
	{
		"curdate": "2014-08-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 60,
		"temperature_1_high": 74,
		"temperature_1_low": 60,
		"temperature_2_high": 76,
		"temperature_2_low": 60,
		"temperature_3_high": 72,
		"temperature_3_low": 60,
		"observed_high": 71,
		"observed_low": 60
	},
	{
		"curdate": "2014-09-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 76,
		"temperature_0_low": 60,
		"temperature_1_high": 70,
		"temperature_1_low": 59,
		"temperature_2_high": 71,
		"temperature_2_low": 59,
		"temperature_3_high": 72,
		"temperature_3_low": 59,
		"observed_high": 74,
		"observed_low": 59
	},
	{
		"curdate": "2014-09-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 58,
		"temperature_1_high": 71,
		"temperature_1_low": 59,
		"temperature_2_high": 71,
		"temperature_2_low": 59,
		"temperature_3_high": 73,
		"temperature_3_low": 58,
		"observed_high": 65,
		"observed_low": 58
	},
	{
		"curdate": "2014-09-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 58,
		"temperature_1_high": 73,
		"temperature_1_low": 58,
		"temperature_2_high": 73,
		"temperature_2_low": 58,
		"temperature_3_high": 75,
		"temperature_3_low": 59,
		"observed_high": 69,
		"observed_low": 59
	},
	{
		"curdate": "2014-09-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 58,
		"temperature_1_high": 73,
		"temperature_1_low": 57,
		"temperature_2_high": 72,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 68,
		"observed_low": 59
	},
	{
		"curdate": "2014-09-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 57,
		"temperature_1_high": 69,
		"temperature_1_low": 56,
		"temperature_2_high": 68,
		"temperature_2_low": 57,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 67,
		"observed_low": 59
	},
	{
		"curdate": "2014-09-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 56,
		"temperature_1_high": 68,
		"temperature_1_low": 57,
		"temperature_2_high": 71,
		"temperature_2_low": 58,
		"temperature_3_high": 75,
		"temperature_3_low": 59,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-09-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 57,
		"temperature_1_high": 74,
		"temperature_1_low": 58,
		"temperature_2_high": 74,
		"temperature_2_low": 60,
		"temperature_3_high": 76,
		"temperature_3_low": 61,
		"observed_high": 66,
		"observed_low": 57
	},
	{
		"curdate": "2014-09-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 73,
		"temperature_0_low": 59,
		"temperature_1_high": 76,
		"temperature_1_low": 59,
		"temperature_2_high": 75,
		"temperature_2_low": 61,
		"temperature_3_high": 77,
		"temperature_3_low": 61,
		"observed_high": 80,
		"observed_low": 57
	},
	{
		"curdate": "2014-09-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 77,
		"temperature_0_low": 60,
		"temperature_1_high": 76,
		"temperature_1_low": 60,
		"temperature_2_high": 73,
		"temperature_2_low": 59,
		"temperature_3_high": 74,
		"temperature_3_low": 60,
		"observed_high": 68,
		"observed_low": 56
	},
	{
		"curdate": "2014-09-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 74,
		"temperature_0_low": 60,
		"temperature_1_high": 74,
		"temperature_1_low": 59,
		"temperature_2_high": 72,
		"temperature_2_low": 59,
		"temperature_3_high": 72,
		"temperature_3_low": 59,
		"observed_high": 68,
		"observed_low": 56
	},
	{
		"curdate": "2014-09-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 60,
		"temperature_1_high": 70,
		"temperature_1_low": 59,
		"temperature_2_high": 70,
		"temperature_2_low": 59,
		"temperature_3_high": 71,
		"temperature_3_low": 61,
		"observed_high": 70,
		"observed_low": 58
	},
	{
		"curdate": "2014-09-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 71,
		"temperature_0_low": 59,
		"temperature_1_high": 70,
		"temperature_1_low": 62,
		"temperature_2_high": 71,
		"temperature_2_low": 60,
		"temperature_3_high": 73,
		"temperature_3_low": 60,
		"observed_high": 75,
		"observed_low": 60
	},
	{
		"curdate": "2014-09-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 71,
		"temperature_0_low": 63,
		"temperature_1_high": 72,
		"temperature_1_low": 62,
		"temperature_2_high": 72,
		"temperature_2_low": 61,
		"temperature_3_high": 72,
		"temperature_3_low": 61,
		"observed_high": 74,
		"observed_low": 62
	},
	{
		"curdate": "2014-09-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 60,
		"temperature_1_high": 71,
		"temperature_1_low": 60,
		"temperature_2_high": 71,
		"temperature_2_low": 59,
		"temperature_3_high": 72,
		"temperature_3_low": 59,
		"observed_high": 68,
		"observed_low": 62
	},
	{
		"curdate": "2014-09-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 60,
		"temperature_1_high": 70,
		"temperature_1_low": 60,
		"temperature_2_high": 71,
		"temperature_2_low": 60,
		"temperature_3_high": 72,
		"temperature_3_low": 61,
		"observed_high": 67,
		"observed_low": 62
	},
	{
		"curdate": "2014-09-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 61,
		"temperature_1_high": 73,
		"temperature_1_low": 63,
		"temperature_2_high": 73,
		"temperature_2_low": 62,
		"temperature_3_high": 70,
		"temperature_3_low": 59,
		"observed_high": 71,
		"observed_low": 62
	},
	{
		"curdate": "2014-09-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 62,
		"temperature_1_high": 73,
		"temperature_1_low": 62,
		"temperature_2_high": 71,
		"temperature_2_low": 60,
		"temperature_3_high": 70,
		"temperature_3_low": 58,
		"observed_high": 75,
		"observed_low": 62
	},
	{
		"curdate": "2014-09-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 59,
		"temperature_1_high": 72,
		"temperature_1_low": 55,
		"temperature_2_high": 77,
		"temperature_2_low": 59,
		"temperature_3_high": 82,
		"temperature_3_low": 65,
		"observed_high": 69,
		"observed_low": 58
	},
	{
		"curdate": "2014-10-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 77,
		"temperature_0_low": 59,
		"temperature_1_high": 82,
		"temperature_1_low": 60,
		"temperature_2_high": 84,
		"temperature_2_low": 62,
		"temperature_3_high": 80,
		"temperature_3_low": 59,
		"observed_high": 82,
		"observed_low": 59
	},
	{
		"curdate": "2014-10-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 87,
		"temperature_0_low": 61,
		"temperature_1_high": 84,
		"temperature_1_low": 59,
		"temperature_2_high": 80,
		"temperature_2_low": 59,
		"temperature_3_high": 77,
		"temperature_3_low": 60,
		"observed_high": 92,
		"observed_low": 65
	},
	{
		"curdate": "2014-10-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 80,
		"temperature_0_low": 58,
		"temperature_1_high": 77,
		"temperature_1_low": 58,
		"temperature_2_high": 76,
		"temperature_2_low": 58,
		"temperature_3_high": 73,
		"temperature_3_low": 58,
		"observed_high": 91,
		"observed_low": 63
	},
	{
		"curdate": "2014-10-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 76,
		"temperature_0_low": 59,
		"temperature_1_high": 76,
		"temperature_1_low": 59,
		"temperature_2_high": 73,
		"temperature_2_low": 59,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 73,
		"observed_low": 55
	},
	{
		"curdate": "2014-10-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 58,
		"temperature_1_high": 72,
		"temperature_1_low": 58,
		"temperature_2_high": 70,
		"temperature_2_low": 58,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 66,
		"observed_low": 55
	},
	{
		"curdate": "2014-10-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 56,
		"temperature_1_high": 72,
		"temperature_1_low": 57,
		"temperature_2_high": 79,
		"temperature_2_low": 60,
		"temperature_3_high": 80,
		"temperature_3_low": 58,
		"observed_high": 64,
		"observed_low": 56
	},
	{
		"curdate": "2014-10-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 72,
		"temperature_0_low": 56,
		"temperature_1_high": 79,
		"temperature_1_low": 56,
		"temperature_2_high": 74,
		"temperature_2_low": 59,
		"temperature_3_high": 69,
		"temperature_3_low": 58,
		"observed_high": 71,
		"observed_low": 55
	},
	{
		"curdate": "2014-10-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 85,
		"temperature_0_low": 58,
		"temperature_1_high": 75,
		"temperature_1_low": 58,
		"temperature_2_high": 68,
		"temperature_2_low": 58,
		"temperature_3_high": 67,
		"temperature_3_low": 54,
		"observed_high": 79,
		"observed_low": 59
	},
	{
		"curdate": "2014-10-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 59,
		"temperature_1_high": 68,
		"temperature_1_low": 55,
		"temperature_2_high": 67,
		"temperature_2_low": 56,
		"temperature_3_high": 68,
		"temperature_3_low": 59,
		"observed_high": 68,
		"observed_low": 58
	},
	{
		"curdate": "2014-10-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 54,
		"temperature_1_high": 67,
		"temperature_1_low": 56,
		"temperature_2_high": 68,
		"temperature_2_low": 57,
		"temperature_3_high": 71,
		"temperature_3_low": 56,
		"observed_high": 68,
		"observed_low": 56
	},
	{
		"curdate": "2014-10-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 71,
		"temperature_0_low": 58,
		"temperature_1_high": 68,
		"temperature_1_low": 57,
		"temperature_2_high": 67,
		"temperature_2_low": 55,
		"temperature_3_high": 67,
		"temperature_3_low": 54,
		"observed_high": 76,
		"observed_low": 63
	},
	{
		"curdate": "2014-10-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 58,
		"temperature_1_high": 67,
		"temperature_1_low": 54,
		"temperature_2_high": 67,
		"temperature_2_low": 54,
		"temperature_3_high": 70,
		"temperature_3_low": 54,
		"observed_high": 70,
		"observed_low": 58
	},
	{
		"curdate": "2014-10-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 54,
		"temperature_1_high": 67,
		"temperature_1_low": 54,
		"temperature_2_high": 68,
		"temperature_2_low": 56,
		"temperature_3_high": 70,
		"temperature_3_low": 58,
		"observed_high": 67,
		"observed_low": 59
	},
	{
		"curdate": "2014-10-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 55,
		"temperature_1_high": 69,
		"temperature_1_low": 57,
		"temperature_2_high": 69,
		"temperature_2_low": 59,
		"temperature_3_high": 70,
		"temperature_3_low": 58,
		"observed_high": 70,
		"observed_low": 56
	},
	{
		"curdate": "2014-10-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 59,
		"temperature_1_high": 68,
		"temperature_1_low": 55,
		"temperature_2_high": 67,
		"temperature_2_low": 53,
		"temperature_3_high": 68,
		"temperature_3_low": 52,
		"observed_high": 68,
		"observed_low": 58
	},
	{
		"curdate": "2014-10-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 68,
		"temperature_0_low": 55,
		"temperature_1_high": 68,
		"temperature_1_low": 53,
		"temperature_2_high": 67,
		"temperature_2_low": 52,
		"temperature_3_high": 70,
		"temperature_3_low": 54,
		"observed_high": 69,
		"observed_low": 59
	},
	{
		"curdate": "2014-10-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 67,
		"temperature_0_low": 53,
		"temperature_1_high": 67,
		"temperature_1_low": 52,
		"temperature_2_high": 69,
		"temperature_2_low": 54,
		"temperature_3_high": 72,
		"temperature_3_low": 55,
		"observed_high": 66,
		"observed_low": 54
	},
	{
		"curdate": "2014-10-28",
		"location": "san-francisco-ca",
		"temperature_0_high": 69,
		"temperature_0_low": 54,
		"temperature_1_high": 72,
		"temperature_1_low": 56,
		"temperature_2_high": 68,
		"temperature_2_low": 57,
		"temperature_3_high": 64,
		"temperature_3_low": 52,
		"observed_high": 69,
		"observed_low": 55
	},
	{
		"curdate": "2014-10-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 73,
		"temperature_0_low": 55,
		"temperature_1_high": 68,
		"temperature_1_low": 56,
		"temperature_2_high": 63,
		"temperature_2_low": 53,
		"temperature_3_high": 63,
		"temperature_3_low": 50,
		"observed_high": 79,
		"observed_low": 57
	},
	{
		"curdate": "2014-10-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 70,
		"temperature_0_low": 57,
		"temperature_1_high": 63,
		"temperature_1_low": 53,
		"temperature_2_high": 64,
		"temperature_2_low": 51,
		"temperature_3_high": 66,
		"temperature_3_low": 50,
		"observed_high": 62,
		"observed_low": 57
	},
	{
		"curdate": "2014-11-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 51,
		"temperature_1_high": 65,
		"temperature_1_low": 50,
		"temperature_2_high": 67,
		"temperature_2_low": 50,
		"temperature_3_high": 69,
		"temperature_3_low": 52,
		"observed_high": 64,
		"observed_low": 55
	},
	{
		"curdate": "2014-11-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 50,
		"temperature_1_high": 67,
		"temperature_1_low": 51,
		"temperature_2_high": 68,
		"temperature_2_low": 53,
		"temperature_3_high": 73,
		"temperature_3_low": 54,
		"observed_high": 64,
		"observed_low": 53
	},
	{
		"curdate": "2014-11-03",
		"location": "san-francisco-ca",
		"temperature_0_high": 66,
		"temperature_0_low": 51,
		"temperature_1_high": 68,
		"temperature_1_low": 53,
		"temperature_2_high": 72,
		"temperature_2_low": 54,
		"temperature_3_high": 70,
		"temperature_3_low": 52,
		"observed_high": 68,
		"observed_low": 52
	},
	{
		"curdate": "2014-11-11",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 53,
		"temperature_1_high": 63,
		"temperature_1_low": 52,
		"temperature_2_high": 64,
		"temperature_2_low": 56,
		"temperature_3_high": 66,
		"temperature_3_low": 51,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-11-12",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 55,
		"temperature_1_high": 65,
		"temperature_1_low": 52,
		"temperature_2_high": 64,
		"temperature_2_low": 49,
		"temperature_3_high": 64,
		"temperature_3_low": 52,
		"observed_high": 65,
		"observed_low": 56
	},
	{
		"curdate": "2014-11-13",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 53,
		"temperature_1_high": 63,
		"temperature_1_low": 50,
		"temperature_2_high": 63,
		"temperature_2_low": 53,
		"temperature_3_high": 65,
		"temperature_3_low": 52,
		"observed_high": 63,
		"observed_low": 55
	},
	{
		"curdate": "2014-11-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 52,
		"temperature_1_high": 63,
		"temperature_1_low": 51,
		"temperature_2_high": 64,
		"temperature_2_low": 49,
		"temperature_3_high": 66,
		"temperature_3_low": 52,
		"observed_high": 65,
		"observed_low": 53
	},
	{
		"curdate": "2014-11-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 49,
		"temperature_1_high": 66,
		"temperature_1_low": 51,
		"temperature_2_high": 66,
		"temperature_2_low": 56,
		"temperature_3_high": 62,
		"temperature_3_low": 54,
		"observed_high": 63,
		"observed_low": 56
	},
	{
		"curdate": "2014-11-17",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 50,
		"temperature_1_high": 65,
		"temperature_1_low": 53,
		"temperature_2_high": 64,
		"temperature_2_low": 51,
		"temperature_3_high": 61,
		"temperature_3_low": 51,
		"observed_high": 66,
		"observed_low": 52
	},
	{
		"curdate": "2014-11-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 64,
		"temperature_0_low": 54,
		"temperature_1_high": 62,
		"temperature_1_low": 51,
		"temperature_2_high": 60,
		"temperature_2_low": 50,
		"temperature_3_high": 61,
		"temperature_3_low": 53,
		"observed_high": 61,
		"observed_low": 55
	},
	{
		"curdate": "2014-11-20",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 49,
		"temperature_1_high": 60,
		"temperature_1_low": 52,
		"temperature_2_high": 63,
		"temperature_2_low": 48,
		"temperature_3_high": 62,
		"temperature_3_low": 50,
		"observed_high": 58,
		"observed_low": 54
	},
	{
		"curdate": "2014-11-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 53,
		"temperature_1_high": 63,
		"temperature_1_low": 48,
		"temperature_2_high": 62,
		"temperature_2_low": 48,
		"temperature_3_high": 63,
		"temperature_3_low": 48,
		"observed_high": 61,
		"observed_low": 54
	},
	{
		"curdate": "2014-11-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 49,
		"temperature_1_high": 62,
		"temperature_1_low": 48,
		"temperature_2_high": 63,
		"temperature_2_low": 49,
		"temperature_3_high": 66,
		"temperature_3_low": 49,
		"observed_high": 65,
		"observed_low": 51
	},
	{
		"curdate": "2014-11-24",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 49,
		"temperature_1_high": 65,
		"temperature_1_low": 50,
		"temperature_2_high": 66,
		"temperature_2_low": 51,
		"temperature_3_high": 65,
		"temperature_3_low": 50,
		"observed_high": 66,
		"observed_low": 50
	},
	{
		"curdate": "2014-11-26",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 51,
		"temperature_1_high": 66,
		"temperature_1_low": 49,
		"temperature_2_high": 64,
		"temperature_2_low": 51,
		"temperature_3_high": 61,
		"temperature_3_low": 53,
		"observed_high": 68,
		"observed_low": 53
	},
	{
		"curdate": "2014-11-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 65,
		"temperature_0_low": 48,
		"temperature_1_high": 59,
		"temperature_1_low": 52,
		"temperature_2_high": 60,
		"temperature_2_low": 53,
		"temperature_3_high": 60,
		"temperature_3_low": 54,
		"observed_high": 67,
		"observed_low": 53
	},
	{
		"curdate": "2014-11-28",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 53,
		"temperature_1_high": 60,
		"temperature_1_low": 52,
		"temperature_2_high": 60,
		"temperature_2_low": 53,
		"temperature_3_high": 63,
		"temperature_3_low": 53,
		"observed_high": 63,
		"observed_low": 49
	},
	{
		"curdate": "2014-11-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 53,
		"temperature_1_high": 60,
		"temperature_1_low": 53,
		"temperature_2_high": 64,
		"temperature_2_low": 54,
		"temperature_3_high": 61,
		"temperature_3_low": 54,
		"observed_high": 60,
		"observed_low": 54
	},
	{
		"curdate": "2014-12-01",
		"location": "san-francisco-ca",
		"temperature_0_high": 60,
		"temperature_0_low": 54,
		"temperature_1_high": 64,
		"temperature_1_low": 54,
		"temperature_2_high": 60,
		"temperature_2_low": 55,
		"temperature_3_high": 62,
		"temperature_3_low": 53,
		"observed_high": 65,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-02",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 56,
		"temperature_1_high": 63,
		"temperature_1_low": 55,
		"temperature_2_high": 63,
		"temperature_2_low": 52,
		"temperature_3_high": 61,
		"temperature_3_low": 52,
		"observed_high": 61,
		"observed_low": 55
	},
	{
		"curdate": "2014-12-04",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 55,
		"temperature_1_high": 63,
		"temperature_1_low": 54,
		"temperature_2_high": 62,
		"temperature_2_low": 55,
		"temperature_3_high": 63,
		"temperature_3_low": 53,
		"observed_high": 66,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-05",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 55,
		"temperature_1_high": 62,
		"temperature_1_low": 53,
		"temperature_2_high": 62,
		"temperature_2_low": 55,
		"temperature_3_high": 62,
		"temperature_3_low": 54,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-06",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 54,
		"temperature_1_high": 63,
		"temperature_1_low": 55,
		"temperature_2_high": 63,
		"temperature_2_low": 53,
		"temperature_3_high": 62,
		"temperature_3_low": 52,
		"observed_high": 66,
		"observed_low": 58
	},
	{
		"curdate": "2014-12-08",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 55,
		"temperature_1_high": 63,
		"temperature_1_low": 54,
		"temperature_2_high": 63,
		"temperature_2_low": 52,
		"temperature_3_high": 62,
		"temperature_3_low": 57,
		"observed_high": 68,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-09",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 53,
		"temperature_1_high": 62,
		"temperature_1_low": 57,
		"temperature_2_high": 61,
		"temperature_2_low": 51,
		"temperature_3_high": 57,
		"temperature_3_low": 48,
		"observed_high": 63,
		"observed_low": 58
	},
	{
		"curdate": "2014-12-10",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 57,
		"temperature_1_high": 61,
		"temperature_1_low": 50,
		"temperature_2_high": 58,
		"temperature_2_low": 48,
		"temperature_3_high": 57,
		"temperature_3_low": 46,
		"observed_high": 64,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-14",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 48,
		"temperature_1_high": 58,
		"temperature_1_low": 51,
		"temperature_2_high": 56,
		"temperature_2_low": 50,
		"temperature_3_high": 57,
		"temperature_3_low": 50,
		"observed_high": 59,
		"observed_low": 50
	},
	{
		"curdate": "2014-12-15",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 51,
		"temperature_1_high": 57,
		"temperature_1_low": 50,
		"temperature_2_high": 57,
		"temperature_2_low": 47,
		"temperature_3_high": 57,
		"temperature_3_low": 49,
		"observed_high": 55,
		"observed_low": 50
	},
	{
		"curdate": "2014-12-16",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 50,
		"temperature_1_high": 57,
		"temperature_1_low": 49,
		"temperature_2_high": 58,
		"temperature_2_low": 51,
		"temperature_3_high": 59,
		"temperature_3_low": 49,
		"observed_high": 61,
		"observed_low": 50
	},
	{
		"curdate": "2014-12-18",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 52,
		"temperature_1_high": 59,
		"temperature_1_low": 50,
		"temperature_2_high": 59,
		"temperature_2_low": 51,
		"temperature_3_high": 62,
		"temperature_3_low": 52,
		"observed_high": 60,
		"observed_low": 50
	},
	{
		"curdate": "2014-12-19",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 50,
		"temperature_1_high": 59,
		"temperature_1_low": 53,
		"temperature_2_high": 62,
		"temperature_2_low": 52,
		"temperature_3_high": 62,
		"temperature_3_low": 51,
		"observed_high": 57,
		"observed_low": 54
	},
	{
		"curdate": "2014-12-21",
		"location": "san-francisco-ca",
		"temperature_0_high": 59,
		"temperature_0_low": 55,
		"temperature_1_high": 62,
		"temperature_1_low": 53,
		"temperature_2_high": 63,
		"temperature_2_low": 51,
		"temperature_3_high": 63,
		"temperature_3_low": 50,
		"observed_high": 62,
		"observed_low": 57
	},
	{
		"curdate": "2014-12-22",
		"location": "san-francisco-ca",
		"temperature_0_high": 63,
		"temperature_0_low": 52,
		"temperature_1_high": 62,
		"temperature_1_low": 50,
		"temperature_2_high": 60,
		"temperature_2_low": 49,
		"temperature_3_high": 59,
		"temperature_3_low": 47,
		"observed_high": 64,
		"observed_low": 54
	},
	{
		"curdate": "2014-12-23",
		"location": "san-francisco-ca",
		"temperature_0_high": 62,
		"temperature_0_low": 50,
		"temperature_1_high": 58,
		"temperature_1_low": 47,
		"temperature_2_high": 56,
		"temperature_2_low": 46,
		"temperature_3_high": 57,
		"temperature_3_low": 44,
		"observed_high": 68,
		"observed_low": 53
	},
	{
		"curdate": "2014-12-25",
		"location": "san-francisco-ca",
		"temperature_0_high": 61,
		"temperature_0_low": 46,
		"temperature_1_high": 56,
		"temperature_1_low": 44,
		"temperature_2_high": 56,
		"temperature_2_low": 43,
		"temperature_3_high": 56,
		"temperature_3_low": 44,
		"observed_high": 57,
		"observed_low": 47
	},
	{
		"curdate": "2014-12-26",
		"location": "san-francisco-ca",
		"temperature_0_high": 57,
		"temperature_0_low": 43,
		"temperature_1_high": 55,
		"temperature_1_low": 44,
		"temperature_2_high": 56,
		"temperature_2_low": 45,
		"temperature_3_high": 54,
		"temperature_3_low": 41,
		"observed_high": 58,
		"observed_low": 48
	},
	{
		"curdate": "2014-12-27",
		"location": "san-francisco-ca",
		"temperature_0_high": 55,
		"temperature_0_low": 45,
		"temperature_1_high": 56,
		"temperature_1_low": 44,
		"temperature_2_high": 55,
		"temperature_2_low": 44,
		"temperature_3_high": 54,
		"temperature_3_low": 41,
		"observed_high": 55,
		"observed_low": 45
	},
	{
		"curdate": "2014-12-29",
		"location": "san-francisco-ca",
		"temperature_0_high": 56,
		"temperature_0_low": 44,
		"temperature_1_high": 54,
		"temperature_1_low": 43,
		"temperature_2_high": 53,
		"temperature_2_low": 41,
		"temperature_3_high": 53,
		"temperature_3_low": 41,
		"observed_high": 54,
		"observed_low": 46
	},
	{
		"curdate": "2014-12-30",
		"location": "san-francisco-ca",
		"temperature_0_high": 53,
		"temperature_0_low": 41,
		"temperature_1_high": 54,
		"temperature_1_low": 43,
		"temperature_2_high": 53,
		"temperature_2_low": 41,
		"temperature_3_high": 55,
		"temperature_3_low": 43,
		"observed_high": 53,
		"observed_low": 45
	},
	{
		"curdate": "2014-12-31",
		"location": "san-francisco-ca",
		"temperature_0_high": 54,
		"temperature_0_low": 43,
		"temperature_1_high": 53,
		"temperature_1_low": 41,
		"temperature_2_high": 54,
		"temperature_2_low": 44,
		"temperature_3_high": 57,
		"temperature_3_low": 45,
		"observed_high": 57,
		"observed_low": 45
	},
	{
		"curdate": "2014-01-01",
		"location": "new-york-ny",
		"temperature_0_high": 32,
		"temperature_0_low": 25,
		"temperature_1_high": 32,
		"temperature_1_low": 29,
		"temperature_2_high": 33,
		"temperature_2_low": 14,
		"temperature_3_high": 16,
		"temperature_3_low": 5,
		"observed_high": 33,
		"observed_low": 24
	},
	{
		"curdate": "2014-01-03",
		"location": "new-york-ny",
		"temperature_0_high": 27,
		"temperature_0_low": 14,
		"temperature_1_high": 15,
		"temperature_1_low": 5,
		"temperature_2_high": 26,
		"temperature_2_low": 22,
		"temperature_3_high": 42,
		"temperature_3_low": 40,
		"observed_high": 18,
		"observed_low": 9
	},
	{
		"curdate": "2014-01-05",
		"location": "new-york-ny",
		"temperature_0_high": 44,
		"temperature_0_low": 44,
		"temperature_1_high": 50,
		"temperature_1_low": 8,
		"temperature_2_high": 13,
		"temperature_2_low": 5,
		"temperature_3_high": 25,
		"temperature_3_low": 21,
		"observed_high": 40,
		"observed_low": 27
	},
	{
		"curdate": "2014-01-07",
		"location": "new-york-ny",
		"temperature_0_high": 13,
		"temperature_0_low": 8,
		"temperature_1_high": 25,
		"temperature_1_low": 21,
		"temperature_2_high": 34,
		"temperature_2_low": 29,
		"temperature_3_high": 40,
		"temperature_3_low": 34,
		"observed_high": 19,
		"observed_low": 4
	},
	{
		"curdate": "2014-01-09",
		"location": "new-york-ny",
		"temperature_0_high": 32,
		"temperature_0_low": 29,
		"temperature_1_high": 40,
		"temperature_1_low": 38,
		"temperature_2_high": 56,
		"temperature_2_low": 46,
		"temperature_3_high": 49,
		"temperature_3_low": 38,
		"observed_high": 32,
		"observed_low": 22
	},
	{
		"curdate": "2014-01-11",
		"location": "new-york-ny",
		"temperature_0_high": 59,
		"temperature_0_low": 42,
		"temperature_1_high": 47,
		"temperature_1_low": 36,
		"temperature_2_high": 51,
		"temperature_2_low": 41,
		"temperature_3_high": 48,
		"temperature_3_low": 35,
		"observed_high": 58,
		"observed_low": 37
	},
	{
		"curdate": "2014-01-02",
		"location": "new-york-ny",
		"temperature_0_high": 33,
		"temperature_0_low": 27,
		"temperature_1_high": 31,
		"temperature_1_low": 14,
		"temperature_2_high": 16,
		"temperature_2_low": 5,
		"temperature_3_high": 25,
		"temperature_3_low": 22,
		"observed_high": 33,
		"observed_low": 18
	},
	{
		"curdate": "2014-01-04",
		"location": "new-york-ny",
		"temperature_0_high": 26,
		"temperature_0_low": 22,
		"temperature_1_high": 42,
		"temperature_1_low": 42,
		"temperature_2_high": 47,
		"temperature_2_low": 8,
		"temperature_3_high": 13,
		"temperature_3_low": 5,
		"observed_high": 29,
		"observed_low": 8
	},
	{
		"curdate": "2014-01-06",
		"location": "new-york-ny",
		"temperature_0_high": 50,
		"temperature_0_low": 9,
		"temperature_1_high": 14,
		"temperature_1_low": 10,
		"temperature_2_high": 25,
		"temperature_2_low": 24,
		"temperature_3_high": 36,
		"temperature_3_low": 32,
		"observed_high": 55,
		"observed_low": 19
	},
	{
		"curdate": "2014-01-08",
		"location": "new-york-ny",
		"temperature_0_high": 23,
		"temperature_0_low": 19,
		"temperature_1_high": 32,
		"temperature_1_low": 29,
		"temperature_2_high": 40,
		"temperature_2_low": 38,
		"temperature_3_high": 54,
		"temperature_3_low": 49,
		"observed_high": 22,
		"observed_low": 9
	},
	{
		"curdate": "2014-01-10",
		"location": "new-york-ny",
		"temperature_0_high": 42,
		"temperature_0_low": 40,
		"temperature_1_high": 59,
		"temperature_1_low": 45,
		"temperature_2_high": 47,
		"temperature_2_low": 38,
		"temperature_3_high": 51,
		"temperature_3_low": 38,
		"observed_high": 37,
		"observed_low": 30
	},
	{
		"curdate": "2014-01-12",
		"location": "new-york-ny",
		"temperature_0_high": 47,
		"temperature_0_low": 36,
		"temperature_1_high": 53,
		"temperature_1_low": 41,
		"temperature_2_high": 48,
		"temperature_2_low": 37,
		"temperature_3_high": 41,
		"temperature_3_low": 28,
		"observed_high": 54,
		"observed_low": 38
	},
	{
		"curdate": "2014-01-13",
		"location": "new-york-ny",
		"temperature_0_high": 53,
		"temperature_0_low": 44,
		"temperature_1_high": 50,
		"temperature_1_low": 40,
		"temperature_2_high": 44,
		"temperature_2_low": 30,
		"temperature_3_high": 38,
		"temperature_3_low": 29,
		"observed_high": 51,
		"observed_low": 37
	},
	{
		"curdate": "2014-01-14",
		"location": "new-york-ny",
		"temperature_0_high": 54,
		"temperature_0_low": 40,
		"temperature_1_high": 50,
		"temperature_1_low": 34,
		"temperature_2_high": 43,
		"temperature_2_low": 29,
		"temperature_3_high": 44,
		"temperature_3_low": 30,
		"observed_high": 52,
		"observed_low": 44
	},
	{
		"curdate": "2014-01-15",
		"location": "new-york-ny",
		"temperature_0_high": 50,
		"temperature_0_low": 37,
		"temperature_1_high": 43,
		"temperature_1_low": 31,
		"temperature_2_high": 44,
		"temperature_2_low": 32,
		"temperature_3_high": 39,
		"temperature_3_low": 27,
		"observed_high": 47,
		"observed_low": 39
	},
	{
		"curdate": "2014-01-16",
		"location": "new-york-ny",
		"temperature_0_high": 42,
		"temperature_0_low": 33,
		"temperature_1_high": 46,
		"temperature_1_low": 35,
		"temperature_2_high": 39,
		"temperature_2_low": 27,
		"temperature_3_high": 38,
		"temperature_3_low": 29,
		"observed_high": 42,
		"observed_low": 36
	},
	{
		"curdate": "2014-01-17",
		"location": "new-york-ny",
		"temperature_0_high": 46,
		"temperature_0_low": 35,
		"temperature_1_high": 42,
		"temperature_1_low": 27,
		"temperature_2_high": 38,
		"temperature_2_low": 29,
		"temperature_3_high": 40,
		"temperature_3_low": 21,
		"observed_high": 44,
		"observed_low": 33
	},
	{
		"curdate": "2014-01-18",
		"location": "new-york-ny",
		"temperature_0_high": 38,
		"temperature_0_low": 27,
		"temperature_1_high": 40,
		"temperature_1_low": 29,
		"temperature_2_high": 42,
		"temperature_2_low": 21,
		"temperature_3_high": 24,
		"temperature_3_low": 10,
		"observed_high": 41,
		"observed_low": 29
	},
	{
		"curdate": "2014-01-19",
		"location": "new-york-ny",
		"temperature_0_high": 40,
		"temperature_0_low": 29,
		"temperature_1_high": 44,
		"temperature_1_low": 21,
		"temperature_2_high": 24,
		"temperature_2_low": 10,
		"temperature_3_high": 18,
		"temperature_3_low": 14,
		"observed_high": 38,
		"observed_low": 24
	},
	{
		"curdate": "2014-01-20",
		"location": "new-york-ny",
		"temperature_0_high": 44,
		"temperature_0_low": 21,
		"temperature_1_high": 22,
		"temperature_1_low": 8,
		"temperature_2_high": 15,
		"temperature_2_low": 8,
		"temperature_3_high": 24,
		"temperature_3_low": 10,
		"observed_high": 46,
		"observed_low": 31
	},
	{
		"curdate": "2014-01-21",
		"location": "new-york-ny",
		"temperature_0_high": 25,
		"temperature_0_low": 8,
		"temperature_1_high": 13,
		"temperature_1_low": 8,
		"temperature_2_high": 21,
		"temperature_2_low": 6,
		"temperature_3_high": 18,
		"temperature_3_low": 15,
		"observed_high": 31,
		"observed_low": 11
	},
	{
		"curdate": "2014-01-22",
		"location": "new-york-ny",
		"temperature_0_high": 16,
		"temperature_0_low": 6,
		"temperature_1_high": 21,
		"temperature_1_low": 10,
		"temperature_2_high": 18,
		"temperature_2_low": 15,
		"temperature_3_high": 33,
		"temperature_3_low": 16,
		"observed_high": 17,
		"observed_low": 5
	},
	{
		"curdate": "2014-02-10",
		"location": "new-york-ny",
		"temperature_0_high": 30,
		"temperature_0_low": 17,
		"temperature_1_high": 26,
		"temperature_1_low": 16,
		"temperature_2_high": 30,
		"temperature_2_low": 24,
		"temperature_3_high": 38,
		"temperature_3_low": 32,
		"observed_high": 29,
		"observed_low": 21
	},
	{
		"curdate": "2014-02-25",
		"location": "new-york-ny",
		"temperature_0_high": 33,
		"temperature_0_low": 23,
		"temperature_1_high": 31,
		"temperature_1_low": 18,
		"temperature_2_high": 30,
		"temperature_2_low": 14,
		"temperature_3_high": 24,
		"temperature_3_low": 19,
		"observed_high": 33,
		"observed_low": 24
	},
	{
		"curdate": "2014-06-26",
		"location": "new-york-ny",
		"temperature_0_high": 85,
		"temperature_0_low": 70,
		"temperature_1_high": 84,
		"temperature_1_low": 68,
		"temperature_2_high": 83,
		"temperature_2_low": 66,
		"temperature_3_high": 81,
		"temperature_3_low": 66,
		"observed_high": 85,
		"observed_low": 70
	},
	{
		"curdate": "2014-09-09",
		"location": "new-york-ny",
		"temperature_0_high": 24,
		"temperature_0_low": 18,
		"temperature_1_high": 26,
		"temperature_1_low": 19,
		"temperature_2_high": 28,
		"temperature_2_low": 18,
		"temperature_3_high": 25,
		"temperature_3_low": 15,
		"observed_high": 73,
		"observed_low": 63
	},
	{
		"curdate": "2014-09-20",
		"location": "new-york-ny",
		"temperature_0_high": 75,
		"temperature_0_low": 67,
		"temperature_1_high": 80,
		"temperature_1_low": 65,
		"temperature_2_high": 75,
		"temperature_2_low": 53,
		"temperature_3_high": 72,
		"temperature_3_low": 57,
		"observed_high": 75,
		"observed_low": 57
	},
	{
		"curdate": "2014-09-21",
		"location": "new-york-ny",
		"temperature_0_high": 27,
		"temperature_0_low": 18,
		"temperature_1_high": 24,
		"temperature_1_low": 11,
		"temperature_2_high": 22,
		"temperature_2_low": 14,
		"temperature_3_high": 22,
		"temperature_3_low": 12,
		"observed_high": 75,
		"observed_low": 67
	},
	{
		"curdate": "2014-09-29",
		"location": "new-york-ny",
		"temperature_0_high": 28,
		"temperature_0_low": 19,
		"temperature_1_high": 26,
		"temperature_1_low": 18,
		"temperature_2_high": 24,
		"temperature_2_low": 16,
		"temperature_3_high": 22,
		"temperature_3_low": 16,
		"observed_high": 79,
		"observed_low": 67
	},
	{
		"curdate": "2014-10-07",
		"location": "new-york-ny",
		"temperature_0_high": 73,
		"temperature_0_low": 62,
		"temperature_1_high": 72,
		"temperature_1_low": 54,
		"temperature_2_high": 64,
		"temperature_2_low": 52,
		"temperature_3_high": 64,
		"temperature_3_low": 52,
		"observed_high": 71,
		"observed_low": 63
	},
	{
		"curdate": "2014-10-12",
		"location": "new-york-ny",
		"temperature_0_high": 13,
		"temperature_0_low": 8,
		"temperature_1_high": 16,
		"temperature_1_low": 11,
		"temperature_2_high": 19,
		"temperature_2_low": 17,
		"temperature_3_high": 22,
		"temperature_3_low": 18,
		"observed_high": 63,
		"observed_low": 48
	},
	{
		"curdate": "2014-10-15",
		"location": "new-york-ny",
		"temperature_0_high": 78,
		"temperature_0_low": 66,
		"temperature_1_high": 70,
		"temperature_1_low": 58,
		"temperature_2_high": 68,
		"temperature_2_low": 58,
		"temperature_3_high": 69,
		"temperature_3_low": 51,
		"observed_high": 77,
		"observed_low": 69
	},
	{
		"curdate": "2014-10-19",
		"location": "new-york-ny",
		"temperature_0_high": 55,
		"temperature_0_low": 42,
		"temperature_1_high": 58,
		"temperature_1_low": 53,
		"temperature_2_high": 63,
		"temperature_2_low": 52,
		"temperature_3_high": 60,
		"temperature_3_low": 53,
		"observed_high": 56,
		"observed_low": 44
	},
	{
		"curdate": "2014-10-25",
		"location": "new-york-ny",
		"temperature_0_high": 18,
		"temperature_0_low": 12,
		"temperature_1_high": 16,
		"temperature_1_low": 9,
		"temperature_2_high": 16,
		"temperature_2_low": 12,
		"temperature_3_high": 22,
		"temperature_3_low": 15,
		"observed_high": 67,
		"observed_low": 50
	},
	{
		"curdate": "2014-10-29",
		"location": "new-york-ny",
		"temperature_0_high": 71,
		"temperature_0_low": 48,
		"temperature_1_high": 58,
		"temperature_1_low": 45,
		"temperature_2_high": 56,
		"temperature_2_low": 48,
		"temperature_3_high": 53,
		"temperature_3_low": 40,
		"observed_high": 72,
		"observed_low": 51
	},
	{
		"curdate": "2014-11-03",
		"location": "new-york-ny",
		"temperature_0_high": 59,
		"temperature_0_low": 48,
		"temperature_1_high": 63,
		"temperature_1_low": 53,
		"temperature_2_high": 67,
		"temperature_2_low": 54,
		"temperature_3_high": 60,
		"temperature_3_low": 49,
		"observed_high": 61,
		"observed_low": 39
	},
	{
		"curdate": "2014-11-19",
		"location": "new-york-ny",
		"temperature_0_high": 34,
		"temperature_0_low": 32,
		"temperature_1_high": 44,
		"temperature_1_low": 28,
		"temperature_2_high": 39,
		"temperature_2_low": 31,
		"temperature_3_high": 42,
		"temperature_3_low": 39,
		"observed_high": 36,
		"observed_low": 22
	},
	{
		"curdate": "2014-11-20",
		"location": "new-york-ny",
		"temperature_0_high": 44,
		"temperature_0_low": 28,
		"temperature_1_high": 37,
		"temperature_1_low": 28,
		"temperature_2_high": 42,
		"temperature_2_low": 36,
		"temperature_3_high": 54,
		"temperature_3_low": 52,
		"observed_high": 45,
		"observed_low": 31
	},
	{
		"curdate": "2014-12-04",
		"location": "new-york-ny",
		"temperature_0_high": 44,
		"temperature_0_low": 34,
		"temperature_1_high": 47,
		"temperature_1_low": 46,
		"temperature_2_high": 56,
		"temperature_2_low": 38,
		"temperature_3_high": 43,
		"temperature_3_low": 34,
		"observed_high": 45,
		"observed_low": 37
	},
	{
		"curdate": "2014-12-13",
		"location": "new-york-ny",
		"temperature_0_high": 38,
		"temperature_0_low": 30,
		"temperature_1_high": 41,
		"temperature_1_low": 34,
		"temperature_2_high": 45,
		"temperature_2_low": 34,
		"temperature_3_high": 46,
		"temperature_3_low": 35,
		"observed_high": 44,
		"observed_low": 34
	},
	{
		"curdate": "2014-01-02",
		"location": "miami-fl",
		"temperature_0_high": 82,
		"temperature_0_low": 73,
		"temperature_1_high": 83,
		"temperature_1_low": 66,
		"temperature_2_high": 71,
		"temperature_2_low": 62,
		"temperature_3_high": 77,
		"temperature_3_low": 70,
		"observed_high": 84,
		"observed_low": 71
	},
	{
		"curdate": "2014-01-04",
		"location": "miami-fl",
		"temperature_0_high": 76,
		"temperature_0_low": 70,
		"temperature_1_high": 81,
		"temperature_1_low": 69,
		"temperature_2_high": 79,
		"temperature_2_low": 49,
		"temperature_3_high": 60,
		"temperature_3_low": 52,
		"observed_high": 76,
		"observed_low": 61
	},
	{
		"curdate": "2014-01-06",
		"location": "miami-fl",
		"temperature_0_high": 85,
		"temperature_0_low": 48,
		"temperature_1_high": 62,
		"temperature_1_low": 55,
		"temperature_2_high": 75,
		"temperature_2_low": 71,
		"temperature_3_high": 82,
		"temperature_3_low": 70,
		"observed_high": 85,
		"observed_low": 58
	},
	{
		"curdate": "2014-01-08",
		"location": "miami-fl",
		"temperature_0_high": 74,
		"temperature_0_low": 70,
		"temperature_1_high": 81,
		"temperature_1_low": 71,
		"temperature_2_high": 83,
		"temperature_2_low": 74,
		"temperature_3_high": 83,
		"temperature_3_low": 71,
		"observed_high": 72,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-10",
		"location": "miami-fl",
		"temperature_0_high": 82,
		"temperature_0_low": 75,
		"temperature_1_high": 84,
		"temperature_1_low": 70,
		"temperature_2_high": 80,
		"temperature_2_low": 70,
		"temperature_3_high": 83,
		"temperature_3_low": 73,
		"observed_high": 81,
		"observed_low": 72
	},
	{
		"curdate": "2014-01-12",
		"location": "miami-fl",
		"temperature_0_high": 79,
		"temperature_0_low": 68,
		"temperature_1_high": 81,
		"temperature_1_low": 68,
		"temperature_2_high": 81,
		"temperature_2_low": 65,
		"temperature_3_high": 72,
		"temperature_3_low": 48,
		"observed_high": 81,
		"observed_low": 66
	},
	{
		"curdate": "2014-01-13",
		"location": "miami-fl",
		"temperature_0_high": 81,
		"temperature_0_low": 70,
		"temperature_1_high": 82,
		"temperature_1_low": 64,
		"temperature_2_high": 73,
		"temperature_2_low": 47,
		"temperature_3_high": 63,
		"temperature_3_low": 45,
		"observed_high": 81,
		"observed_low": 65
	},
	{
		"curdate": "2014-01-14",
		"location": "miami-fl",
		"temperature_0_high": 83,
		"temperature_0_low": 65,
		"temperature_1_high": 73,
		"temperature_1_low": 51,
		"temperature_2_high": 62,
		"temperature_2_low": 43,
		"temperature_3_high": 69,
		"temperature_3_low": 47,
		"observed_high": 84,
		"observed_low": 70
	},
	{
		"curdate": "2014-01-15",
		"location": "miami-fl",
		"temperature_0_high": 75,
		"temperature_0_low": 55,
		"temperature_1_high": 63,
		"temperature_1_low": 45,
		"temperature_2_high": 68,
		"temperature_2_low": 50,
		"temperature_3_high": 63,
		"temperature_3_low": 45,
		"observed_high": 72,
		"observed_low": 60
	},
	{
		"curdate": "2014-01-16",
		"location": "miami-fl",
		"temperature_0_high": 65,
		"temperature_0_low": 43,
		"temperature_1_high": 68,
		"temperature_1_low": 52,
		"temperature_2_high": 68,
		"temperature_2_low": 43,
		"temperature_3_high": 70,
		"temperature_3_low": 52,
		"observed_high": 61,
		"observed_low": 50
	},
	{
		"curdate": "2014-01-17",
		"location": "miami-fl",
		"temperature_0_high": 68,
		"temperature_0_low": 49,
		"temperature_1_high": 70,
		"temperature_1_low": 44,
		"temperature_2_high": 71,
		"temperature_2_low": 52,
		"temperature_3_high": 72,
		"temperature_3_low": 56,
		"observed_high": 66,
		"observed_low": 46
	},
	{
		"curdate": "2014-01-18",
		"location": "miami-fl",
		"temperature_0_high": 70,
		"temperature_0_low": 45,
		"temperature_1_high": 71,
		"temperature_1_low": 53,
		"temperature_2_high": 74,
		"temperature_2_low": 61,
		"temperature_3_high": 76,
		"temperature_3_low": 51,
		"observed_high": 69,
		"observed_low": 52
	},
	{
		"curdate": "2014-01-19",
		"location": "miami-fl",
		"temperature_0_high": 70,
		"temperature_0_low": 53,
		"temperature_1_high": 75,
		"temperature_1_low": 59,
		"temperature_2_high": 75,
		"temperature_2_low": 52,
		"temperature_3_high": 66,
		"temperature_3_low": 52,
		"observed_high": 69,
		"observed_low": 46
	},
	{
		"curdate": "2014-01-20",
		"location": "miami-fl",
		"temperature_0_high": 74,
		"temperature_0_low": 61,
		"temperature_1_high": 76,
		"temperature_1_low": 52,
		"temperature_2_high": 63,
		"temperature_2_low": 48,
		"temperature_3_high": 72,
		"temperature_3_low": 58,
		"observed_high": 76,
		"observed_low": 54
	},
	{
		"curdate": "2014-01-21",
		"location": "miami-fl",
		"temperature_0_high": 76,
		"temperature_0_low": 52,
		"temperature_1_high": 64,
		"temperature_1_low": 46,
		"temperature_2_high": 70,
		"temperature_2_low": 55,
		"temperature_3_high": 71,
		"temperature_3_low": 52,
		"observed_high": 73,
		"observed_low": 61
	},
	{
		"curdate": "2014-01-22",
		"location": "miami-fl",
		"temperature_0_high": 66,
		"temperature_0_low": 48,
		"temperature_1_high": 70,
		"temperature_1_low": 53,
		"temperature_2_high": 70,
		"temperature_2_low": 52,
		"temperature_3_high": 72,
		"temperature_3_low": 54,
		"observed_high": 66,
		"observed_low": 52
	},
	{
		"curdate": "2014-04-06",
		"location": "miami-fl",
		"temperature_0_high": 85,
		"temperature_0_low": 73,
		"temperature_1_high": 86,
		"temperature_1_low": 74,
		"temperature_2_high": 89,
		"temperature_2_low": 65,
		"temperature_3_high": 77,
		"temperature_3_low": 64,
		"observed_high": 84,
		"observed_low": 69
	},
	{
		"curdate": "2014-07-10",
		"location": "miami-fl",
		"temperature_0_high": 90,
		"temperature_0_low": 77,
		"temperature_1_high": 89,
		"temperature_1_low": 77,
		"temperature_2_high": 89,
		"temperature_2_low": 77,
		"temperature_3_high": 89,
		"temperature_3_low": 77,
		"observed_high": 90,
		"observed_low": 76
	},
	{
		"curdate": "2014-09-20",
		"location": "miami-fl",
		"temperature_0_high": 90,
		"temperature_0_low": 74,
		"temperature_1_high": 88,
		"temperature_1_low": 75,
		"temperature_2_high": 88,
		"temperature_2_low": 76,
		"temperature_3_high": 86,
		"temperature_3_low": 77,
		"observed_high": 90,
		"observed_low": 74
	},
	{
		"curdate": "2014-09-24",
		"location": "miami-fl",
		"temperature_0_high": 29,
		"temperature_0_low": 25,
		"temperature_1_high": 31,
		"temperature_1_low": 25,
		"temperature_2_high": 31,
		"temperature_2_low": 26,
		"temperature_3_high": 31,
		"temperature_3_low": 26,
		"observed_high": 87,
		"observed_low": 75
	},
	{
		"curdate": "2014-10-08",
		"location": "miami-fl",
		"temperature_0_high": 88,
		"temperature_0_low": 76,
		"temperature_1_high": 88,
		"temperature_1_low": 76,
		"temperature_2_high": 88,
		"temperature_2_low": 76,
		"temperature_3_high": 89,
		"temperature_3_low": 76,
		"observed_high": 88,
		"observed_low": 74
	},
	{
		"curdate": "2014-10-13",
		"location": "miami-fl",
		"temperature_0_high": 88,
		"temperature_0_low": 78,
		"temperature_1_high": 89,
		"temperature_1_low": 77,
		"temperature_2_high": 90,
		"temperature_2_low": 73,
		"temperature_3_high": 86,
		"temperature_3_low": 70,
		"observed_high": 88,
		"observed_low": 77
	},
	{
		"curdate": "2014-10-22",
		"location": "miami-fl",
		"temperature_0_high": 80,
		"temperature_0_low": 72,
		"temperature_1_high": 84,
		"temperature_1_low": 73,
		"temperature_2_high": 82,
		"temperature_2_low": 74,
		"temperature_3_high": 82,
		"temperature_3_low": 72,
		"observed_high": 85,
		"observed_low": 74
	},
	{
		"curdate": "2014-10-27",
		"location": "miami-fl",
		"temperature_0_high": 28,
		"temperature_0_low": 23,
		"temperature_1_high": 29,
		"temperature_1_low": 22,
		"temperature_2_high": 30,
		"temperature_2_low": 22,
		"temperature_3_high": 29,
		"temperature_3_low": 21,
		"observed_high": 83,
		"observed_low": 67
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data2.json
// module id = 177
// module chunks = 0